export default __webpack_public_path__ + "static/media/ArrowLeftSkinnyIcon.4aa8cc31.svg";